import modelsResolver from 'utils/api/models/utils/modelsResolver';
import { SingleCommitmentDetails } from './singleCommitmentDetails';

export type CommitmentDetails = {
	accountCode: string;
	subscriberNo: string;
	sumOfActiveCommitmentPenaltyAmount: number;
	sumOfActiveRate: number;
	sumOfActiveRemainingAmount: number;
	sumOfActiveTotalAmount: number;
	sumOfCommitmentPenaltyAmount: number;
	sumOfRate: number;
	sumOfRemainingAmount: number;
	sumOfTotalAmount: number;
	_commitmentDetails: any;
	commitmentDetails: SingleCommitmentDetails[];
};

const model: types.models.InputModel = {
	accountCode: 'accountCode',
	subscriberNo: 'subscriberNo',
	sumOfActiveCommitmentPenaltyAmount: 'sumOfActiveCommitmentPenaltyAmount',
	sumOfActiveRate: 'sumOfActiveRate',
	sumOfActiveRemainingAmount: 'sumOfActiveRemainingAmount',
	sumOfActiveTotalAmount: 'sumOfActiveTotalAmount',
	sumOfCommitmentPenaltyAmount: 'sumOfCommitmentPenaltyAmount',
	sumOfRate: 'sumOfRate',
	sumOfRemainingAmount: 'sumOfRemainingAmount',
	sumOfTotalAmount: 'sumOfTotalAmount',
	_commitmentDetails: 'commitmentDetails',
	commitmentDetails: (model: CommitmentDetails) =>
		model._commitmentDetails.map((singleCommitmentDetails: any) =>
			modelsResolver(singleCommitmentDetails, 'singleCommitmentDetails')
		)
	};

export default model;
